import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import SkeletonOne from "../../skeleton/SkeletonOne";
import {
    UserAccountFollow,
    otherUserFollowingList
} from "../../../redux/ApiSlice/AccountProfileSlice";

export const FollowingTab = ({ datalist, otheruser_id, searchTerm = "", hasMore = false, loadingMore = false, onLoadMore, serverFiltered = false, searching = false }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [filteredList, setFilteredList] = useState([]);
    const [sentinelEl, setSentinelEl] = useState(null);

    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile, loading } = ProfileDetails || {};

    useEffect(() => {
        if (!hasMore || loadingMore || searchTerm || !sentinelEl) return;
        const observer = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) onLoadMore?.(); },
            { threshold: 0 }
        );
        observer.observe(sentinelEl);
        return () => observer.disconnect();
    }, [hasMore, loadingMore, searchTerm, onLoadMore, sentinelEl]);

    const handleFollowFun = async (userId) => {
        await dispatch(UserAccountFollow(userId));
        if (otheruser_id) {
            await dispatch(otherUserFollowingList(otheruser_id));
        }

        setFilteredList((prevList) =>
            prevList.map((item) =>
                item.following_id === userId
                    ? { ...item, is_following: !item.is_following } : item
            )
        );
    };

    useEffect(() => {
        if (serverFiltered || !searchTerm) {
            setFilteredList(datalist || []);
        } else {
            const lower = searchTerm.toLowerCase();
            setFilteredList(
                (datalist || []).filter(item => {
                    const name = (item.following_full_name || item.full_name || item.following?.full_name || item?.user_full_name || "").toString();
                    return name.toLowerCase().includes(lower);
                })
            );
        }
    }, [searchTerm, datalist, serverFiltered]);

    return (
        <section className="h-full overflow-y-auto">
            {loading ? (
                <SkeletonOne />
            ) : filteredList?.length ? (
                <div className="pb-4">
                    {filteredList?.map((item) => (
                        <div className="flex items-center py-2 border-b border-gray-300 dark:border-gray-800/50">
                            <div className="flex justify-between w-full px-2" key={item.id}>
                                <div className="col-span-9 flex items-start gap-x-1.5 relative rounded-full">
                                    <img
                                        src={item.following_avatar_url}
                                        onClick={() => navigate(User_profile.id == item?.following_id ? `/account` : `/account/${item.following_id}`)}
                                        className="h-10 w-10 rounded-full object-cover cursor-pointer border border-gray-300 dark:border-gray-800/50 bg-gray-100 dark:bg-gray-800/50"
                                    />
                                    <div className="flex flex-col">
                                        <p
                                            onClick={() => navigate(User_profile.id == item?.following_id ? `/account` : `/account/${item.following_id}`)}
                                            className="text-[11px] first-letter:uppercase font-bold text-gray-600 dark:text-white"
                                        >
                                            {item.following_full_name}
                                        </p>
                                        <div className={`flex items-center gap-x-1 ${item?.mutual_friends?.length !== 0 && "mt-1"}`}>
                                            <div className="flex -space-x-2 overflow-hidden">
                                                {((item?.mutual_friends || item?.mutual || item?.mutual_friends_list) || []).map((friends, index) => {
                                                    if (index >= 3) return null;
                                                    const avatar = friends?.avatar_url || friends?.follower_avatar_url || friends?.following_avatar_url || friends?.user_avatar || '';
                                                    const key = friends?.id || friends?.user_id || index;
                                                    return (
                                                        <img
                                                            alt="img"
                                                            key={key}
                                                            src={avatar}
                                                            onClick={() => navigate(`/mutual-friends/${item?.following_id}`)}
                                                            className="inline-block h-5 w-5 rounded-full object-cover cursor-pointer"
                                                        />
                                                    );
                                                })}
                                            </div>
                                            <p className={`text-[10px] text-gray-400 dark:text-gray-500 cursor-pointer whitespace-nowrap ${item?.mutual_friends?.length === 0 ? "-ml-1" : ""}`}>
                                                {item?.mutual_friends?.length > 0
                                                    ? `${item.mutual_friends.length} mutual`
                                                    : "No mutual"
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {User_profile?.id !== item?.following_id && <div className="flex justify-center items-center">
                                    {(item?.is_following && !otheruser_id ? <button
                                        onClick={() => handleFollowFun(item.following_id)}
                                        className="w-[4.2rem] bg-[#BDE6FF] hover:bg-[#A0D8FF] text-black text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                    >
                                        Unfollow
                                    </button> :
                                        item.is_follower && !item.is_following ? (
                                            <button
                                                onClick={() => handleFollowFun(item?.following_id)}
                                                className="w-[4.2rem] bg-[#BDE6FF] hover:bg-[#A0D8FF] text-black text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                            >
                                                Follow Back
                                            </button>
                                        ) : !item.is_follower && item.is_following || item.is_follower && item.is_following ? <button
                                            onClick={() => handleFollowFun(item?.following_id)}
                                            className="w-[4.2rem] bg-gray-800 hover:bg-gray-900 text-white text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                        >
                                            Following
                                        </button> : <button
                                            onClick={() => handleFollowFun(item?.following_id)}
                                            className="w-[4.2rem] bg-[#BDE6FF] hover:bg-[#A0D8FF] text-black text-[10px] font-semibold py-1 rounded-md whitespace-nowrap"
                                        >
                                            Follow
                                        </button>)}
                                </div>}
                            </div>
                        </div>
                    ))}
                    {!searchTerm && (
                        <div ref={setSentinelEl} className="flex justify-center py-4">
                            {loadingMore && <span className="text-[12px] text-gray-400 dark:text-gray-500">Loading...</span>}
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex justify-center items-center h-[50%] w-full">
                    <p className="text-[12px] text-gray-600 dark:text-gray-200 mt-5">
                        {searching ? 'Searching...' : searchTerm ? 'No result found' : 'After you follow people, you will see them here'}
                    </p>
                </div>
            )}
        </section >
    );
};